import memoryStore from './memoryStore.js';
export default globalThis.localStorage || memoryStore;